export const dashboard = {
  contact: {
    title: 'Unggah kontak',
    button: 'Unggah',
    description: 'Memulai Zorra, Unggah dan masukkan database clients atau numbers telepon clients.'
  },

  mailing: {
    title: 'Judul surat',
    button: 'Ok',
    description: 'Buat pesan untuk sms atau gunakan templat yang telah ditentukan sebelumnya.'
  },

  number: {
    title: 'Pesan a nomor',
    button: 'Pesan',
    description: 'Informasi tambahan mungkin diperlukan selama proses pembelian'
  },

  pbx: {
    title: 'Set Up Virtual PBX',
    button: 'Set Up',
    description: 'Layanan Zorra memberikan solusi cloud untuk server telepon VoIP.'
  },

  api: {
    title: 'API dan Integrasi',
    button: 'Integrasikan',
    description:
      'Layanan Zorra memungkinkan sistem integrasi yang kuat. Untuk menggunakan Zorra API, Anda harus menambahkan Alamat IP server Anda di sini'
  },

  prices: {
    title: 'Services dan Harga',
    button: 'Pelajari',
    description:
      'Apakah Anda ingin menerapkan e-mail marketing, tetapi tidak tahu apa yang Anda butuhkan untuk ini?'
  },

  first_entry: {
    title: 'Terima kasih sudah mendaftar!',
    text: `Kredensial akun telah dikirim ke email Anda. <br /> <b>{value} {currency} selamat</b> datang telah dikreditkan ke akun Anda.`,
    start: 'Mulai menggunakan'
  },

  'data-base': {
    title: 'Hubungi basis pelanggan',
    title2: 'Panggilan prediktif',
    description:
      'Panggilan prediktif memungkinkan Anda untuk dengan cepat memanggil sejumlah besar angka dan pada saat yang sama menyediakan hampir 100% beban operator.',
    button: 'Pergi',
    button2: 'Plug'
  },

  noty: {
    'connect-autocaller': 'Prediktif akan terhubung dalam beberapa menit.'
  },

  'low-balance': 'Dana di saldo Anda akan segera habis, kami sarankan untuk mengisinya kembali.',
  'unavailable_zorra': 'Peringatan Pemeliharaan: Layanan tidak akan tersedia pada 6 Desember 2023 mulai pukul 07:00 hingga 11:00 UTC',

  captcha:
    'This site is protected by reCAPTCHA and the Google <br />' +
    'Privacy Policy and Terms of Service apply.'
};
